import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

// Paths that are always allowed regardless of account_status
const ALLOWED_PATHS = ['/complete-profile', '/pending-approval', '/privacy', '/terms', '/', '/auth-callback', '/investors', '/tester-guide'];
const ALLOWED_PREFIXES = ['/parent-consent/'];

export default function AccountStatusGate({ children }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading || !user) return;

    const path = location.pathname;
    const isAllowed = ALLOWED_PATHS.includes(path) || ALLOWED_PREFIXES.some(p => path.startsWith(p));
    if (isAllowed) return;

    const status = user.account_status;
    // Legacy users without account_status = active (grandfather)
    if (!status || status === 'active') return;

    if (status === 'pending_profile') {
      navigate('/complete-profile', { replace: true });
    } else if (status === 'pending_parent_approval') {
      navigate('/pending-approval', { replace: true });
    } else if (status === 'denied') {
      navigate('/pending-approval', { replace: true });
    }
  }, [user, loading, location.pathname, navigate]);

  return children;
}
